class MinerwaHero extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-slide]')];
    if (this.slides.length === 0) return;

    this.current = 0;
    this.timer = null;
    this.autoplayMs = (Number(this.dataset.autoplay) || 0) * 1000;

    this.slides.forEach((slide, i) => {
      slide.dataset.state = i === 0 ? 'current' : 'after';
    });

    if (this.slides.length > 1) {
      this.querySelector('[data-hero-prev]')?.addEventListener('click', () => {
        this.go(-1);
        this.restartAutoplay();
      });
      this.querySelector('[data-hero-next]')?.addEventListener('click', () => {
        this.go(1);
        this.restartAutoplay();
      });

      this.observer = new IntersectionObserver(
        ([entry]) => (entry.isIntersecting ? this.startAutoplay() : this.stopAutoplay()),
        { threshold: 0.1 },
      );
      this.observer.observe(this);
    }
  }

  disconnectedCallback() {
    this.stopAutoplay();
    this.observer?.disconnect();
  }

  go(direction) {
    const total = this.slides.length;
    const next = (this.current + direction + total) % total;
    if (next === this.current) return;

    const outgoing = this.slides[this.current];
    const incoming = this.slides[next];

    incoming.dataset.instant = '';
    incoming.dataset.state = direction > 0 ? 'after' : 'before';

    void incoming.offsetWidth;

    requestAnimationFrame(() => {
      delete incoming.dataset.instant;
      incoming.dataset.state = 'current';
      outgoing.dataset.state = direction > 0 ? 'before' : 'after';
    });

    outgoing.setAttribute('aria-hidden', 'true');
    incoming.removeAttribute('aria-hidden');
    outgoing.querySelector('.minerwa-hero__link')?.setAttribute('tabindex', '-1');
    incoming.querySelector('.minerwa-hero__link')?.removeAttribute('tabindex');

    this.current = next;
  }

  startAutoplay() {
    if (this.timer || !this.autoplayMs) return;
    this.timer = setInterval(() => this.go(1), this.autoplayMs);
  }

  stopAutoplay() {
    clearInterval(this.timer);
    this.timer = null;
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}

if (!customElements.get('minerwa-hero')) {
  customElements.define('minerwa-hero', MinerwaHero);
}
